import { createVariant } from '../../utils/createVariant';
export const ContentTitleMobile = createVariant({
    name: 'content-title-mobile',
    tagName: 'h3',
    baseStyle: ({ theme }) => (Object.assign(Object.assign({}, theme.typography.heading3['400ContentTitleMobile']), { color: theme.colors.base.textTitles })),
});
